export default "__VITE_ASSET__DUXNFKM$__"